var map = {
	"./imgs1.png": "3b20",
	"./imgs2.png": "277d",
	"./imgs3.png": "7482",
	"./imgs4.png": "839b",
	"./imgs5.png": "9efd",
	"./imgs6.png": "06fb",
	"./imgs7.png": "05bd",
	"./imgs8.png": "2f6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b4b0";